import { useLocation, useNavigate } from 'react-router-dom';
import { useEffect, useState } from 'react';
import BranchSelector from '../components/BranchSelector';
import type { Environment, RepoRef } from '../types/environment';
import { fetchDefaultBranches } from '../utils/defaultBranches';

export default function ConfigureBranchesPage() {
    const location = useLocation();
    const navigate = useNavigate();
    const env = (location.state as any)?.env as Environment | undefined;
    const initial = (location.state as any)?.branches as Record<string, string> | undefined;
    const envID = (location.state as any)?.envID as string | undefined;
    const [branches, setBranches] = useState<Record<string, string>>(initial || {});
    const [defaults, setDefaults] = useState<Record<string, string>>({});

    useEffect(() => {
        if (!env) return;
        let cancelled = false;
        fetchDefaultBranches(env.EnvironmentID, env.Repos).then((map) => {
            if (cancelled) return;
            setDefaults(map);
            // Seed branches with fetched defaults for repos the user hasn't
            // touched, so Save persists what the UI is displaying.
            setBranches((prev) => {
                const merged = { ...prev };
                for (const [key, branch] of Object.entries(map)) {
                    if (!merged[key]) merged[key] = branch;
                }
                return merged;
            });
        });
        return () => { cancelled = true; };
    }, [env?.EnvironmentID]);

    if (!env) {
        return <div style={{ padding: '20px' }}>No environment selected</div>;
    }

    const setBranch = (r: RepoRef, b: string) => {
        const key = `${r.Org}/${r.Repo}`;
        setBranches((prev) => ({ ...prev, [key]: b }));
    };

    const handleOK = () => {
        navigate('/tasks/new', { state: { envID: envID || env.EnvironmentID, branches } });
    };

    return (
        <div
            style={{
                padding: '20px',
                display: 'flex',
                flexDirection: 'column',
                gap: '12px',
            }}
        >
            {env.Repos.map((r) => {
                const key = `${r.Org}/${r.Repo}`;
				return (
					<div key={key} style={{ display: 'flex', gap: '8px', alignItems: 'center' }}>
						<div style={{ flex: 1 }}>{r.Org} / {r.Repo}</div>
						<div style={{ flex: 1 }}>
							<BranchSelector
								environmentID={env.EnvironmentID}
								org={r.Org}
								repo={r.Repo}
								value={branches[key] || defaults[key] || 'main'}
								onChange={(b) => setBranch(r, b)}
							/>
						</div>
					</div>
				);
            })}
            <div style={{ display: 'flex', justifyContent: 'center' }}>
                <button onClick={handleOK}>Save</button>
            </div>
        </div>
    );
}
